import React from 'react';
import {Link} from 'react-router-dom';
function tarot() {
    return (
        <div>
                <div component="p" style={{display: 'flex', justifyContent: 'center', 
                                            color: '#e0515d', marginTop: '25px', marginBottom: '20px',
                                            fontSize: '40px', fontFamily: 'balthazar,serif'}}>
                    FREE TAROT READING...
                </div>
                <div style={{width: '33%'}}>
                </div>
                <div component="p" style={{display: 'flex', color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem', justifyContent: 'center',
                                            fontWeight: '400', width: '34%', left: '33%',
                                            textAlign: 'center', position: 'relative',
                                            marginBottom: '25px' 
                                            }}>
                    Know what's in store for you romantically each day with 
                    your Love Tarot reading. Hot date? Drama? Lonely night? 
                    Find out what to expect now...
                </div>
                <div style={{width: '33%'}}>
                </div>
            <div style={{backgroundColor: 'transparent', display: 'table',
                        width: '100%', tableLayout: 'fixed'}}>
                <div style={{width: '33%',display: 'table-cell', color: '#fefefe',
                              fontFamily: 'balthazar,serif',
                              fontSize: '1.8rem', justifyContent: 'center',
                              fontWeight: '400',  
                              textAlign: 'center', position: 'relative' 
                            }}>
                    <div><h1><p style={{color: '#e0515d'}}>LOVE</p></h1>
                        <ul>
                            <li><Link to="/dailyLove"><button style={{backgroundColor: 'transparent'}}>LOVE FORECAST TAROT</button></Link></li>
                            <li><button style={{backgroundColor: 'transparent'}}>LOVE POTENTIAL TAROT</button></li>
                            <li><button style={{backgroundColor: 'transparent'}}>BREAKUP TAROT</button></li>
                            <li><button style={{backgroundColor: 'transparent'}}>DAILY FLIRT TAROT</button></li>
                            <li><button style={{backgroundColor: 'transparent'}}>YEARLY LOVE</button></li>
                        </ul>
                    </div>
                </div>
                <div component="p" style={{display: 'table-cell', color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem', justifyContent: 'center',
                                            fontWeight: '400', width: '33%', 
                                            textAlign: 'center', position: 'relative' 
                                            }}>

                    <div><h1> <p style={{display:'flex', justifyContent:'center', color: '#e0515d'}}>SELF</p>
                    </h1>
                        <ul>
                            <li><button style={{backgroundColor: 'transparent'}}>TAROT CARD MEANING</button></li>
                            <li><button style={{backgroundColor: 'transparent'}}>DAILY TAROT</button></li>
                            <li><button style={{backgroundColor: 'transparent'}}>YES/NO TAROT</button></li>
                            <li><button style={{backgroundColor: 'transparent'}}>YIN YANG TAROT</button></li>
                            <li><button style={{backgroundColor: 'transparent'}}>YEARLY</button></li>
                        </ul>
                    </div>
                </div>
                <div style={{width: 'auto%', display: 'table-cell', color: '#fefefe',
                              fontFamily: 'balthazar,serif',
                              fontSize: '1.8rem', justifyContent: 'center',
                              fontWeight: '400', 
                              textAlign: 'center', position: 'relative' }}>
                    <div>              
                        <h1><p style={{color: '#e0515d'}}>SUCCESS</p></h1>
                        <ul>
                            <li><button style={{backgroundColor: 'transparent'}}>HOW TO READ TAROT</button></li>
                            <li><button style={{backgroundColor: 'transparent'}}>CAREER TAROT</button></li>
                            <li><button style={{backgroundColor: 'transparent'}}>LIVE READING</button></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        )
    }

export default tarot;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarotreading/tarotReadingLanding.js